<template>
    <div :id="`location-${locationData.id}`" class="elle-location">
        <CommonBuilder v-if="status == 'success'" :data="locationData.elements ?? []" />
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    middleware: 'location-i18n',
    pageTransition: usePageTransition()
});

const { locationData, status } = await useLocationPage();
</script>
